export default __webpack_public_path__ + "static/media/Narita_Festival_Girls.8d7a07ff.jpg";